import { render, staticRenderFns } from "./DepositReports.vue?vue&type=template&id=c27d67f8&scoped=true&"
import script from "./DepositReports.vue?vue&type=script&lang=js&"
export * from "./DepositReports.vue?vue&type=script&lang=js&"
import style0 from "./DepositReports.vue?vue&type=style&index=0&id=c27d67f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27d67f8",
  null
  
)

export default component.exports